import type {
  CompanyProfileCollectionRecord,
  CompanyProfileRecord,
  CustomerCategoryRecord,
  WorkspaceSettingsRecord
} from '@shared/types';
import type { SettingsTab } from './settings-view-store';

export interface SettingsTabOption {
  id: SettingsTab;
  labelKey: string;
  icon: 'settings' | 'contracts' | 'invoices' | 'payments' | 'avi' | 'customers' | 'monitor' | 'sync';
}

export function selectSettingsTabs(): SettingsTabOption[] {
  return [
    { id: 'general', labelKey: 'settings.tabs.general', icon: 'settings' },
    { id: 'companyProfiles', labelKey: 'settings.tabs.companyProfiles', icon: 'customers' },
    { id: 'customerTypes', labelKey: 'settings.tabs.customerTypes', icon: 'customers' },
    { id: 'invoicing', labelKey: 'settings.tabs.invoicing', icon: 'invoices' },
    { id: 'contracts', labelKey: 'settings.tabs.contracts', icon: 'contracts' },
    { id: 'localEnvironment', labelKey: 'settings.tabs.localEnvironment', icon: 'monitor' },
    { id: 'payments', labelKey: 'settings.tabs.payments', icon: 'payments' },
    { id: 'integrations', labelKey: 'settings.tabs.integrations', icon: 'sync' },
    { id: 'avi', labelKey: 'settings.tabs.avi', icon: 'avi' },
    { id: 'localization', labelKey: 'settings.tabs.localization', icon: 'settings' }
  ];
}

export function selectCompanyProfileOptions(collection: CompanyProfileCollectionRecord) {
  return collection.companyProfiles.map((profile) => ({
    value: profile.id,
    label: profile.name
  }));
}

export function selectCustomerCategoryDraft(customerCategory: CustomerCategoryRecord | null): CustomerCategoryRecord {
  const timestamp = new Date().toISOString();

  return {
    id: '',
    createdAt: timestamp,
    updatedAt: timestamp,
    deletedAt: null,
    archivedAt: null,
    name: '',
    slug: '',
    iconName: 'briefcaseBusiness',
    sortOrder: 0,
    ...(customerCategory ?? {})
  };
}

export function selectCompanyProfileDraft(companyProfile: CompanyProfileRecord | null, workspaceSettings: WorkspaceSettingsRecord): CompanyProfileRecord {
  if (companyProfile) {
    return companyProfile;
  }

  const timestamp = new Date().toISOString();

  return {
    id: '',
    createdAt: timestamp,
    updatedAt: timestamp,
    deletedAt: null,
    archivedAt: null,
    name: '',
    legalName: '',
    entityType: 'company',
    cui: '',
    registrationNumber: null,
    vatPayer: true,
    addressLine: '',
    city: null,
    county: null,
    postalCode: null,
    country: 'Romania',
    email: null,
    phone: null,
    bankName: null,
    iban: null,
    swift: null,
    invoiceSeries: workspaceSettings.invoicing.defaultSeries,
    defaultCurrency: workspaceSettings.general.defaultCurrency,
    contractSignatureBlock: null,
    isDefault: false
  };
}
